import React, { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import WarningPopupContainer from '@components/commons/popup/container/WarningPopupContainer';
import { setDeeplink } from '@/lib/airbridge';
import { clickWebToAppPopup, viewWebToAppPopup } from '@/lib/eventManager';

interface IWebToAppWarningPopup {
  onClose: () => void;
  storyId: number;
}

const WebToAppWarningPopup = ({ onClose, storyId }: IWebToAppWarningPopup) => {
  const { t } = useTranslation();

  useEffect(() => {
    viewWebToAppPopup();
    setTimeout(() => {
      setDeeplink({ storyId });
    });
  }, []);

  const handleAppDownloadButtonClick = () => {
    clickWebToAppPopup();
    setDeeplink({ storyId });
  };

  return (
    <WarningPopupContainer title={t('webtoapp_popup_label_onlyapp')}>
      <div css={container}>
        <div className="content">
          {t('webtoapp_popup_description_download_app')}
        </div>
        <button
          className="app-button"
          id={'web-to-app-deeplink'}
          onClick={handleAppDownloadButtonClick}
        >
          {t('common_screen_button_app_download')}
        </button>
        <button className="web-button" onClick={onClose}>
          {t('common_popup_title_push_confirm_later')}
        </button>
      </div>
    </WarningPopupContainer>
  );
};

const container = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: 'Apple SD Gothic Neo';

  .content {
    margin-top: 0.5rem;
    font-size: 0.95rem;
    line-height: 1.25rem;
    font-weight: 400;
    letter-spacing: -0.3px;
    text-align: center;
    color: ${theme.colors.gray700};
  }

  .app-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;
    width: 100%;
    height: 3.25rem;
    cursor: pointer;
    background-color: ${theme.colors.primary500};
    color: ${theme.colors.white};
    font-weight: 700;
    line-height: 1.375rem;
    border-radius: 0.5rem;
    font-size: 1rem;
  }

  .web-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1rem;
    font-weight: 400;
    width: 100%;
    font-size: 0.875rem;
    color: ${theme.colors.primary500};
    line-height: 1.375rem;
    cursor: pointer;
  }
`;

export default WebToAppWarningPopup;
